import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
};

export const orderStatusReducer = createReducer(initialState, {  
  // get all orders of delivery partner
  getAllOrderStatusDeliveryRequest: (state) => {
    state.isLoading = true;
  },
  getAllOrderStatusDeliverySuccess: (state, action) => {
    state.isLoading = false;
    state.orderStatuses = action.payload;
  },
  getAllOrderStatusDeliveryFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  // get all orders for admin
  adminAllOrderStatusRequest: (state) => {
    state.adminOrderStatusLoading = true;
  },
  adminAllOrderStatusSuccess: (state, action) => {
    state.adminOrderStatusLoading = false;
    state.adminOrderStatus = action.payload;
  },
  adminAllOrderStatusFailed: (state, action) => {
    state.adminOrderStatusLoading = false;
    state.error = action.payload;
  },

  clearErrors: (state) => {
    state.error = null;
  },
});
